var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bvlvmq6kxa",
    d: "M0 0h15v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qz4x7zkzub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bvlvmq6kxa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8991A3",
    d: "M0 7.585C0 13.402 7.5 20 7.5 20S15 13.25 15 7.585C15.025 3.835 12.042 0 7.592 0 3.143 0 0 3.359 0 7.585",
    mask: "url(#qz4x7zkzub)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10 7.266a2.5 2.5 0 11-2.5-2.501A2.476 2.476 0 0110 7.217v.048z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLocation);
export default __webpack_public_path__ + "static/media/icoLocation.7858ab20.svg";
export { ForwardRef as ReactComponent };